import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'circle-letter-w', 'CircleLetterW', [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"}],["path",{"d":"M9 8l1 8l2 -5l2 5l1 -8"}]]);